import { useEffect } from 'react';

import { supabaseClient } from '@auth-v2';

import { subscribeToSwingThreadMessages } from '@data';
import { queryClient, getSwingThreadMessagesKey } from '@queries';

export const useSwingThreadMessagesSubscription = (threadId?: number) => {
    useEffect(() => {
        if (!threadId) return;
        const sub = subscribeToSwingThreadMessages(supabaseClient, threadId, async () => {
            queryClient.invalidateQueries({ queryKey: getSwingThreadMessagesKey(threadId) });
        });
        return () => {
            sub.unsubscribe();
        };
    }, [supabaseClient, threadId]);
};
